import { NavLink } from "react-router-dom";
import { useLangStore } from "../store/lang";
import { t } from "../i18n/strings";

// Fixed bottom tab bar for ≤768px — the 4 highest-traffic destinations.
// Everything else lives in the hamburger drawer. display:none on desktop.
// Simple inline SVG icons (24px) keep it dependency-free.

function Icon({ name }: { name: "dashboard" | "inbox" | "invoices" | "bills" | "reports" }) {
  const common = { width: 22, height: 22, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.6, strokeLinecap: "round" as const, strokeLinejoin: "round" as const };
  switch (name) {
    case "dashboard":
      return (
        <svg {...common}><rect x="3" y="3" width="7" height="9" rx="1" /><rect x="14" y="3" width="7" height="5" rx="1" /><rect x="14" y="12" width="7" height="9" rx="1" /><rect x="3" y="16" width="7" height="5" rx="1" /></svg>
      );
    case "inbox":
      // Envelope-with-sparkle motif — signals "AI Inbox" (where docs land + get processed)
      return (
        <svg {...common}><path d="M4 6h16v10H4z" /><path d="M4 6l8 6 8-6" /><path d="M18 3l0.7 1.4L20 5l-1.3 0.6L18 7l-0.7-1.4L16 5l1.3-0.6z" /></svg>
      );
    case "invoices":
      return (
        <svg {...common}><path d="M14 3v4a1 1 0 0 0 1 1h4" /><path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z" /><line x1="9" y1="13" x2="15" y2="13" /><line x1="9" y1="17" x2="13" y2="17" /></svg>
      );
    case "bills":
      return (
        <svg {...common}><path d="M5 3v18l3-2 3 2 3-2 3 2 3-2V3l-3 2-3-2-3 2-3-2-3 2z" /><line x1="9" y1="9" x2="15" y2="9" /><line x1="9" y1="13" x2="15" y2="13" /></svg>
      );
    case "reports":
      return (
        <svg {...common}><line x1="4" y1="20" x2="20" y2="20" /><rect x="5" y="12" width="3" height="6" /><rect x="10.5" y="8" width="3" height="10" /><rect x="16" y="4" width="3" height="14" /></svg>
      );
  }
}

const TABS: Array<{ to: string; icon: "dashboard" | "inbox" | "invoices" | "bills" | "reports"; key: string; label?: string }> = [
  { to: "/dashboard", icon: "dashboard", key: "nav.dashboard" },
  { to: "/inbox", icon: "inbox", key: "nav.inbox", label: "Inbox" },
  { to: "/invoices", icon: "invoices", key: "nav.invoices" },
  { to: "/bills", icon: "bills", key: "nav.bills" },
  { to: "/reports", icon: "reports", key: "nav.reports" },
];

export function BottomTabBar() {
  const { lang } = useLangStore();
  return (
    <nav className="bottom-tabs" aria-label="Primary">
      {TABS.map((tab) => {
        const translated = t(tab.key, lang);
        const label = translated && translated !== tab.key ? translated : (tab.label ?? tab.key);
        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) => "bottom-tab" + (isActive ? " active" : "")}
          >
            <Icon name={tab.icon} />
            <span>{label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
